import React from 'react'

import ArrowRight from './../static/images/arrow_right_bold_stroke.svg'

class Auth extends React.PureComponent {
  render = () => (
    <div>
      <h1>{this.props.polyglot.t('account')}</h1>
      <p className='short_col'>{this.props.polyglot.t('desc')}</p>
      <form
        action={this.props.url.login}
        method='get'
        style={{ display: 'inline-block' }}
      >
        <button>
          {this.props.polyglot.t('login')} <img src={ArrowRight} />
        </button>
      </form>
      <span className='tab' />
      <span className='tab' />
      <form
        action={this.props.url.password}
        method='post'
        style={{ display: 'inline-block' }}
        target='_blank'
      >
        <button>
          {this.props.polyglot.t('password')} <img src={ArrowRight} />
        </button>
      </form>
      <span className='tab' />
      <span className='tab' />
      <form
        action={this.props.url.register}
        method='post'
        style={{ display: 'inline-block' }}
        target='_blank'
      >
        <button>
          {this.props.polyglot.t('registration')} <img src={ArrowRight} />
        </button>
      </form>
    </div>
  )
}

export default Auth



// WEBPACK FOOTER //
// ./src/auth.js